interface Props {
  icon: string
  title: string
  desc: string
  tag?: string
  onClick?: () => void
  disabled?: boolean
}

export default function FeatureCard({ icon, title, desc, tag, onClick, disabled }: Props) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`
        group relative bg-[var(--color-surface)] border border-[var(--color-border-default)] rounded-2xl p-4 text-left
        transition-all hover:shadow-md hover:border-[var(--color-border-accent)] hover:-translate-y-0.5
        disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:translate-y-0 disabled:hover:shadow-none
        w-full
      `}
    >
      {tag && (
        <span className="absolute -top-2 -right-1 text-xs bg-[var(--color-accent)] text-[var(--color-primary)] rounded-full px-2 py-0.5 font-bold shadow-sm">
          {tag}
        </span>
      )}
      <div className="text-3xl mb-2">{icon}</div>
      <p className="font-bold text-[var(--color-text-primary)] text-sm">{title}</p>
      <p className="text-[var(--color-text-tertiary)] text-xs mt-0.5 leading-relaxed">{desc}</p>
    </button>
  )
}
